import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TreeSelectModule } from 'primeng/treeselect';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-product-list-edit',
  standalone: true,
  imports: [TagModule, SelectModule, InputTextModule, ButtonModule, TranslateModule, Tabs, TabList, Tab, TabPanels, TabPanel, TreeSelectModule],
  templateUrl: './product-list-edit.component.html',
  styleUrl: './product-list-edit.component.scss',
})
export class ProductListEditComponent implements OnInit {
  buttonOutlined = true;
  buttonEnabled = false;
  categories;
  totalSelected;
  differentCategories;
  constructor(private readonly config: DynamicDialogConfig,
    public readonly ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.categories = this.config.data?.categories;
    this.totalSelected = this.config.data?.totalSelected;
    this.differentCategories = this.config.data?.differentCategories;
  }

  handleSlectableNodes(node) {
    if (node.hasChildren == 'true') {
      node.selectable = false;
      for (let child of node.children) {
        this.handleSlectableNodes(child);
      }
    }
  }

  closeDialog() {
    this.ref.close();
  }
  exitDialog() {
    this.ref.close();
  }
}
